import {
  CreateThreadRequest,
  HumanMessage,
  ProgrammingLanguage,
  SystemMessage,
  AIMessage,
  FunctionMessage,
  ToolMessage,
  ChatMessage,
  ProgrammingLanguageOptions,
  ArtifactType,
  TextHighlight,
  ArtifactV3_Output,
  CodeHighlight,
  UpdateThreadRequest,
} from './api';

export interface CodeEditorData {
  content?: string;
  language?: ProgrammingLanguage;
  undoStepsCount?: number;
  redoStepsCount?: number;
}

export type EditorTheme = 'light' | 'dark' | 'none';

export type CreateEditorThreadRequest = CreateThreadRequest & {
  user_id: string;
};

export type UpdateEditorThreadRequest = UpdateThreadRequest & {
  user_id: string;
  thread_id: string;
};

export enum EditorMessageType {
  HUMAN = 'human',
}

export type EditorMessage =
  | HumanMessage
  | SystemMessage
  | AIMessage
  | ToolMessage
  | FunctionMessage
  | ChatMessage;

export interface ArtifactToolResponse {
  artifact?: string;
  title?: string;
  language?: string;
  type?: ArtifactType;
}

export type RewriteArtifactMetaToolResponse =
  | {
      type: ArtifactType.TEXT;
      title?: string;
      language: ProgrammingLanguageOptions;
    }
  | {
      type: ArtifactType.CODE;
      title: string;
      language: ProgrammingLanguageOptions;
    };

export interface EditorLocalStreamingState {
  rewriteArtifactMeta?: RewriteArtifactMetaToolResponse;
  generateArtifactToolCallStr: string;
  updatedArtifactStartContent?: string;
  updatedArtifactRestContent?: string;
  fullNewArtifactContent: string;
  highlightedText?: TextHighlight;
}

export interface EditorHandleProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  parsedData: any;
  currentArtifactOutput?: ArtifactV3_Output | null;
  localState: EditorLocalStreamingState;
  highlightedCode?: CodeHighlight | null;
}

export type AutoSavingStatus = 'loading' | 'error' | 'success';

export type EditorListTypes = 'bullet' | 'number';
